angular.module('env.data.rest.signalR.notificationHub', [])

    .run(function ($log, $rootScope, authService, notificationHub, rest) {

        notificationHub.onUpdate(function (modelInfo) {
            var id = modelInfo.id;
            var modelType = modelInfo.modelType;
            var version = modelInfo.version;

            rest.modelUpdatedOnServer(modelInfo);

            if (rest.hasModel(modelType, id)) {

                rest.renewModel(modelType, id, version).catch(function (error) {
                    $log.warn(_.str.sprintf(
                        "Model was updated by other client, but we were unable to renew model from server." +
                        "Type: %s; Id: %s. Error: ", modelType, id, error ? error.toString() : "undefined"));
                });
            }
        });

        notificationHub.onCreate(function (modelInfo) {
            rest.modelCreatedOnServer(modelInfo);
        });

        notificationHub.onSignalRConnected(function () {
            signalRLogin();
        });

        function signalRLogin() {
            var token = authService.getToken();
            if (token) {
                notificationHub.initialize(token);
            } else {
                notificationHub.uninitialize();
            }
        }

        function signalRLogout() {
            notificationHub.uninitialize();
        }

        authService.events.on('login', signalRLogin);
        authService.events.on('continueSessionAfterReload', signalRLogin);

        authService.events.on('loginFailed', signalRLogout);
        authService.events.on('logout', signalRLogout);
        authService.events.on('authenticationRequiredAfterReload', signalRLogout);
        authService.events.on('sessionExpired', signalRLogout);

    })

    .service('notificationHub', function ($log, $q, EventingMixin, SignalRHub, pingService) {

        var _this = this;
        _.extend(_this, new EventingMixin([
            'Updated',
            'Created',
            'SignalRConnected'
        ]));

        //declaring the hub connection
        var hub = new SignalRHub('NotificationHub', {

            rootPath: om.config.build.signalRUrl,

            //client side methods
            listeners: {
                "Updated": function (modelType, id, version) {
                    raise("Updated", modelType, id, version);
                },
                "Created": function (modelType, id, version) {
                    raise("Created", modelType, id, version);
                }
            },

            //handle connection error
            errorHandler: function (error) {
                $log.warn("SignalR error: " + error ? error.toString() : "unknown error");
            },

            //server side methods
            methods: ['initialize', 'uninitialize', 'addFilter', 'removeFilter'],

            autoReconnect: true,
            autoReconnectTimeout: 30000, // ms

            onSignalRConnected: function () {
                _this.events.raise("SignalRConnected");
            }
        });

        /**
         * Login for signalR hub
         * @param {string} token security token
         */
        var initialize = function (token) {
            return ensureConnection().then(function () {
                try {
                    return pingService.whenConnected().then(function () {
                        return hub.initialize(token);
                    });
                } catch (e) {
                    $log.error("Error on attempt to login through SignalR connection", e);
                    return $q.reject(e);
                }
            });
        };

        /**
         * Login for signalR hub
         */
        var uninitialize = function () {
            return ensureConnection().then(function () {
                try {
                    return hub.uninitialize();
                } catch (e) {
                    $log.error("Error on attempt to logout through SignalR connection", e);
                    return $q.reject(e);
                }
            });
        };

        /**
         * Subscribe for CREATE event
         * @param {function} func callback
         */
        function onCreate(func) {
            _this.events.on("Created", func)
        }

        /**
         * Subscribe for UPDATE event
         * @param {function} func callback
         */
        function onUpdate(func) {
            _this.events.on("Updated", func)
        }

        /**
         * Subscribe for UPDATE event
         * @param {function} func callback
         */
        function onSignalRConnected(func) {
            _this.events.on("SignalRConnected", func)
        }

        function raise(eventName, serverModelType, id, version) {
            if (id && serverModelType) {
                var modelType = transformServerModelType(serverModelType);
                try {
                    _this.events.raise(eventName, {id: id, modelType: modelType, version: version});
                } catch (e) {
                    $log.warn("Error on handling '" + eventName + "' signalR event", e);
                }
            }
        }

        function transformServerModelType(serverModelType) {
            if (serverModelType == "Action") {
                return "ActionModel";
            }
            if (serverModelType == "Centre") {
                return "CentreModel";
            }
            if (serverModelType == "Comment") {
                return "CommentModel";
            }
            if (serverModelType == "Customer") {
                return "CustomerModel";
            }
            if (serverModelType == "Document") {
                return "DocumentModel";
            }
            if (serverModelType == "OrderItem") {
                return "OrderItemModel";
            }
            if (serverModelType == "Order") {
                return "OrderModel";
            }
            if (serverModelType == "Step") {
                return "StepModel";
            }
            if (serverModelType == "User") {
                return "UserModel";
            }
            throw new Error(_.str.sprintf("Unrecognized model type: %s", serverModelType));
        }

        /**
         * Add new event filter
         * @param {string} typeName type name
         * @param {string} expression filtering expression
         */
        function addFilter(typeName, expression) {
            return ensureConnection().then(function () {
                try {
                    return hub.addFilter(typeName, expression);
                } catch (e) {
                    $log.error("Error on attempt to call SignalR server function 'addFilter'", e);
                    return $q.reject(e);
                }
            });
        }

        /**
         * Remove event filter
         * @param {string} typeName
         */
        function removeFilter(typeName) {
            return ensureConnection().then(function () {
                try {
                    return hub.removeFilter(typeName);
                } catch (e) {
                    $log.error("Error on attempt to call SignalR server function 'removeFilter'", e);
                    return $q.reject(e);
                }
            });
        }

        function ensureConnection() { // todo refactor away to hub
            return hub.ensureConnection();
        }

        _.extend(_this, {
            initialize: initialize,
            uninitialize: uninitialize,
            addFilter: addFilter,
            removeFilter: removeFilter,
            onCreate: onCreate,
            onUpdate: onUpdate,
            onSignalRConnected: onSignalRConnected,
            connectPromise: hub.promise
        });

        return _this;
    })

;
